import React, { useRef, useEffect } from 'react';

function AnimaltHatterJogi() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const alakzatok = Array.from({length: 16}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      meret: Math.random() * 60 + 20,
      vx: (Math.random() - 0.5) * 0.25, vy: (Math.random() - 0.5) * 0.25,
      szin: ['#1a73e8','#34a853','#9c27b0','#f9ab00','#00bcd4'][Math.floor(Math.random()*5)],
      alpha: Math.random() * 0.05 + 0.02,
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      alakzatok.forEach(a => {
        a.x += a.vx; a.y += a.vy;
        if (a.x < -a.meret) a.x = canvas.width + a.meret;
        if (a.x > canvas.width + a.meret) a.x = -a.meret;
        if (a.y < -a.meret) a.y = canvas.height + a.meret;
        if (a.y > canvas.height + a.meret) a.y = -a.meret;
        ctx.beginPath(); ctx.arc(a.x, a.y, a.meret/2, 0, Math.PI*2);
        ctx.fillStyle = a.szin; ctx.globalAlpha = a.alpha; ctx.fill(); ctx.globalAlpha = 1;
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
  .jogi-wrapper * { font-family: 'Nunito', sans-serif !important; }
  .jogi-wrapper h2 { font-size: 22px; font-weight: 900; color: #1a1a2e; margin: 2rem 0 0.75rem; }
  .jogi-wrapper h3 { font-size: 16px; font-weight: 800; color: #1a73e8; margin: 1.25rem 0 0.4rem; }
  .jogi-wrapper p, .jogi-wrapper li { font-size: 15px; color: #444; line-height: 1.8; }
  .jogi-wrapper ul { padding-left: 1.25rem; margin: 0.5rem 0; }
  .jogi-wrapper li { margin-bottom: 0.4rem; }
  .jogi-wrapper strong { color: #1a1a2e; }
  .jogi-wrapper em { color: #888; }
`;

function AdatkezelesiTajekoztato() {
  return (
    <div className="jogi-wrapper" style={{minHeight: '100vh', background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f7ff 50%, #f5fff8 100%)', padding: '3rem 2rem', position: 'relative', overflow: 'hidden'}}>
      <style>{globalStyles}</style>
      <AnimaltHatterJogi/>
      <div style={{position: 'relative', zIndex: 1, maxWidth: '760px', margin: '0 auto'}}>

        <div style={{textAlign: 'center', marginBottom: '2.5rem'}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.9)', border: '2px solid #1a73e8', borderRadius: '50px', padding: '10px 24px', fontSize: '15px', fontWeight: '800', color: '#1a73e8', marginBottom: '1.25rem'}}>
            <span style={{fontSize: '22px'}}>🔒</span> Adatkezelési tájékoztató
          </div>
          <h1 style={{fontSize: '32px', fontWeight: '900', color: '#1a1a2e', margin: '0 0 0.5rem'}}>NetOkos Adatkezelési Tájékoztató</h1>
          <p style={{fontSize: '14px', color: '#888', fontWeight: '700', margin: 0}}>Hatályos: 2026. augusztus 22-től</p>
          <p style={{fontSize: '14px', color: '#888', fontWeight: '700', margin: 0}}>Utolsó frissítés: 2026. augusztus 22.</p>
        </div>

        <div style={{background: 'white', borderRadius: '24px', padding: '2.5rem', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '2px solid #f0f0f0'}}>

          <h2>1. Az adatkezelő</h2>
          <p>
            A NetOkos platformot (elérhető: <strong>netokos.hu</strong>) magánszemélyként, hobbiprojektként üzemeltetem, bevétel- és nyereségszerzési cél nélkül. Nincs önálló vállalkozásom vagy cégformám ehhez a projekthez.
          </p>
          <p>
            <strong>Adatkezelő:</strong> Kovács Magdolna<br/>
            <strong>E-mail:</strong> <a href="mailto:info.netokos@gmail.com" style={{color: '#1a73e8', fontWeight: 700}}>info.netokos@gmail.com</a>
          </p>

          <h2>2. Milyen adatokat kezelünk</h2>
          <p>A NetOkos regisztrációkor és használat közben az alábbi adatokat gyűjti és tárolja:</p>

          <h3>A szülőről / törvényes képviselőről:</h3>
          <ul>
            <li>Név (a regisztrációkor megadott, hogy tudjuk, kit köszöntsünk — ez jelenik meg a profilodon is)</li>
            <li>E-mail cím</li>
            <li>Regisztráció időpontja</li>
            <li>Bejelentkezési mód (email+jelszó, vagy Google-fiók)</li>
            <li>Annak ténye és időpontja, hogy a regisztráló megerősítette: elmúlt 18 éves, és a regisztrált gyermek szülője vagy törvényes képviselője</li>
            <li>Az adatkezelési tájékoztató és az ÁSZF elfogadásának ténye és időpontja</li>
          </ul>

          <h3>A gyermekről (a szülő által megadva):</h3>
          <ul>
            <li>Név vagy becenév</li>
            <li>Korosztály (6–8 / 9–11 / 12–14 év)</li>
            <li>A tanulási előrehaladás (megszerzett XP, teljesített leckék)</li>
          </ul>

          <h3>Technikai adatok:</h3>
          <ul>
            <li>A szolgáltatás működéséhez szükséges technikai naplók (pl. bejelentkezési időbélyegek), amiket a Firebase (Google) infrastruktúrája automatikusan kezel</li>
          </ul>

          <h3>Amit NEM gyűjtünk:</h3>
          <ul>
            <li>Nem kérünk és nem tárolunk a gyermek pontos életkorát, lakcímét, iskolájának nevét, fényképét vagy bármilyen más, a fentieken túli személyes adatot</li>
            <li>Nem használunk hirdetési célú nyomkövető sütiket</li>
          </ul>

          <h2>3. Miért kezeljük ezeket az adatokat (jogalap)</h2>
          <p>
            Az adatkezelés jogalapja a szülő/törvényes képviselő <strong>kifejezett hozzájárulása</strong> (GDPR 6. cikk (1) bekezdés a) pont, és a 8. cikk, mivel a szolgáltatás közvetlenül gyermekeknek szóló, információs társadalommal összefüggő szolgáltatás).
          </p>
          <p>
            A regisztráció során a szülő <strong>három külön jelölőnégyzettel</strong> erősíti meg a hozzájárulását: (1) hogy elmúlt 18 éves, (2) hogy elfogadja a jelen Adatkezelési tájékoztatót, és (3) hogy elfogadja az ÁSZF-et. Mindegyik nyilatkozat elfogadását — külön időbélyeggel — a rendszer eltárolja. Hozzájárulás nélkül a regisztráció nem lehetséges.
          </p>
          <p>
            Azért kérjük kifejezetten a <strong>18 éves kor és a szülői/törvényes képviselői minőség</strong> megerősítését, mert a NetOkos-on a gyermek nem regisztrál önállóan, és nem ő adja a hozzájárulást adatai kezeléséhez — helyette mindig egy, a saját nagykorúságát is megerősítő felnőtt teszi ezt a gyermeke nevében, szülői felügyeleti jogköre alapján. Ez a modell szigorúbb védelmet nyújt, mint a GDPR 8. cikkében rögzített, Magyarországon 16 évben meghatározott digitális beleegyezési korhatár.
          </p>

          <h2>4. Milyen célra használjuk az adatokat</h2>
          <ul>
            <li>A fiók létrehozásához és a bejelentkezés lehetővé tételéhez</li>
            <li>A gyermek tanulási előrehaladásának megjelenítéséhez és mentéséhez</li>
            <li>Egy üdvözlő e-mail kiküldéséhez regisztrációkor</li>
            <li>A szolgáltatás korosztály-specifikus tartalmának helyes megjelenítéséhez</li>
          </ul>
          <p><strong>Az adatokat NEM használjuk:</strong></p>
          <ul>
            <li>Marketing célra</li>
            <li>Harmadik félnek történő értékesítésre vagy továbbadásra</li>
            <li>Profilalkotásra vagy automatizált döntéshozatalra</li>
          </ul>

          <h2>5. Kik férhetnek hozzá az adatokhoz</h2>
          <p>
            Az adatok a <strong>Google Firebase</strong> infrastruktúráján (Firestore adatbázis, Authentication szolgáltatás) vannak tárolva, európai (EU) szerverelhelyezéssel. A Google mint adatfeldolgozó jár el, a Google Cloud adatfeldolgozói szerződése alapján.
          </p>
          <p>Az üdvözlő e-mail küldéséhez a Gmail (Google) levelezőrendszerét használjuk.</p>
          <p>
            Az adatkezelőn (rajtam) és a fent említett technikai szolgáltatókon (Google/Firebase) kívül <strong>senki más nem fér hozzá</strong> az adatokhoz. Nem adjuk el, nem béreljük ki és nem osztjuk meg az adatokat semmilyen más harmadik féllel.
          </p>

          <h2>6. Meddig tároljuk az adatokat</h2>
          <p>
            Az adatokat a fiók fennállásáig tároljuk. A szülő bármikor kérheti a fiók és a hozzá tartozó összes adat végleges törlését — ezt közvetlenül a Profil oldalon, a "Fiók végleges törlése" gombbal is elindíthatja (jelszavas megerősítéssel), vagy írhat a 10. pontban megadott elérhetőségre. A törlésről minden esetben visszaigazoló e-mailt küldünk.
          </p>

          <h2>7. A szülő/törvényes képviselő jogai</h2>
          <p>A GDPR alapján bármikor jogodban áll:</p>
          <ul>
            <li><strong>Hozzáférést kérni</strong> ahhoz, milyen adatokat tárolunk rólad és gyermekedről</li>
            <li><strong>Helyesbítést kérni</strong>, ha valamelyik adat pontatlan</li>
            <li><strong>Törlést kérni</strong> ("elfeledtetéshez való jog") — ez a fiók és minden hozzá tartozó adat végleges törlését jelenti</li>
            <li><strong>Az adatkezelés korlátozását kérni</strong></li>
            <li><strong>Adathordozhatóságot kérni</strong> (az adatok géppel olvasható formában történő átadását)</li>
            <li><strong>A hozzájárulást bármikor visszavonni</strong> — ez a fiók törlésével jár, mivel hozzájárulás nélkül az adatkezelésnek nincs jogalapja</li>
          </ul>
          <p>
            Ezen jogok gyakorlásához írj az <a href="mailto:info.netokos@gmail.com" style={{color: '#1a73e8', fontWeight: 700}}>info.netokos@gmail.com</a> címre. A kérést ésszerű időn (legfeljebb 30 napon) belül teljesítjük.
          </p>

          <h2>8. Panasz benyújtásának lehetősége</h2>
          <p>Ha úgy érzed, jogaid sérültek, panaszt nyújthatsz be a <strong>Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH)</strong>:</p>
          <ul>
            <li>Weboldal: <a href="https://naih.hu" target="_blank" rel="noopener noreferrer" style={{color: '#1a73e8', fontWeight: 700}}>naih.hu</a></li>
            <li>Cím: 1055 Budapest, Falk Miksa utca 9–11.</li>
            <li>E-mail: ugyfelszolgalat@naih.hu</li>
          </ul>

          <h2>9. Sütik (cookie-k)</h2>
          <p>
            A NetOkos jelenleg csak a működéshez feltétlenül szükséges, technikai sütiket használja (pl. a bejelentkezési állapot fenntartásához, Firebase Authentication által). Marketing vagy nyomkövető célú sütit nem alkalmazunk.
          </p>
          <p>
            <em>(Ha a jövőben statisztikai/elemző eszközt — pl. Google Analytics — vezetnénk be, ehhez külön, kifejezett hozzájárulást (cookie-bannert) kell majd bevezetni, és ezt a tájékoztatót frissíteni.)</em>
          </p>

          <h2>10. Kapcsolat</h2>
          <p>
            Bármilyen kérdés esetén: <a href="mailto:info.netokos@gmail.com" style={{color: '#1a73e8', fontWeight: 700}}>info.netokos@gmail.com</a>
          </p>

        </div>

        <div style={{textAlign: 'center', marginTop: '2rem'}}>
          <a href="/" style={{color: '#1a73e8', fontWeight: '800', fontSize: '15px', textDecoration: 'none'}}>← Vissza a főoldalra</a>
        </div>

      </div>
    </div>
  );
}

export default AdatkezelesiTajekoztato;